import { Stack, Divider, Typography, Skeleton, Box } from '@mui/material';
import { FC } from 'react';
import { numberFormatted } from '../../Formatters';
import { SummaryType, isCustomersLine, useSummaryLines } from './summaryUtils';
import { SummaryRow } from './SummaryRow';

export const Summary: FC<{
  summary: SummaryType;
  label?: React.ReactNode;
  actions?: React.ReactNode;
  colorValues?: boolean;
  formatter?: (val: number | undefined) => string | undefined;
}> = ({ summary, label, actions, colorValues, formatter }) => {
  const lines = useSummaryLines();
  if (summary === null) return null;
  return (
    <Stack>
      {label && (
        <Stack sx={{ justifyContent: 'right' }}>
          <Box sx={{ height: (theme) => theme.spacing(3) }}>{actions}</Box>
          {typeof label === 'string' ? <Typography sx={{ fontWeight: 'medium', fontSize: 'small', textAlign: 'right' }}>{label}</Typography> : label}
        </Stack>
      )}
      {(summary === undefined || !lines) && <Skeleton variant="rectangular" height={180} width="100%" sx={{ minWidth: 100 }} />}
      {summary &&
        lines?.map((line) => (
          <Box key={line.key} sx={{ ml: line.level }}>
            {line.isTotal && <Divider />}
            <SummaryRow
              value={summary[line.key] ?? 0}
              colorValue={colorValues}
              formatter={isCustomersLine(line) ? (formatter ?? numberFormatted) : formatter}
            />
          </Box>
        ))}
    </Stack>
  );
};
